import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { __, always, invertObj, isNil, path, pipe, prop, when } from 'ramda';
import { BookingStep } from '../booking.constants';
import history from '../../../shared/utils/history';
import { ROUTES } from '../../routes';

const stepFromRoute = path(['match', 'params', 'step']);

const bookingStepFromStepParam = pipe(
  step => `/book/${step}`,
  prop(__, invertObj(ROUTES.booking)),
  key => parseInt(key, 10),
  when(isNaN, always(null))
);

const bookingStepFromRoute = pipe(
  stepFromRoute,
  bookingStepFromStepParam
);

const parseTransition = (prevStep, nextStep) => {
  const offset = nextStep - prevStep;
  const isAdjacent = Math.abs(offset) === 1;
  const isValueAllowed = Object.values(BookingStep).includes(nextStep);
  const fromSummary = prevStep === BookingStep.SUMMARY;

  return {
    isAllowed: !fromSummary && isAdjacent && isValueAllowed,
    offset,
  };
};

export class StepRouter extends PureComponent {
  static propTypes = {
    children: PropTypes.any,
    experienceUrl: PropTypes.string,
    step: PropTypes.oneOf(Object.values(BookingStep)),
    nextStep: PropTypes.func.isRequired,
    prevStep: PropTypes.func.isRequired,
    match: PropTypes.object, // eslint-disable-line
  };

  componentDidMount() {
    if (bookingStepFromRoute(this.props) !== BookingStep.TIME) {
      history.replace(this.props.experienceUrl + ROUTES.booking[this.props.step]);
    }
  }

  componentDidUpdate(prevProps) {
    this.handleRouteStepChange(prevProps);
    this.handlePropsStepChange(prevProps);
  }

  get needsUpdate() {
    return this.props.step !== bookingStepFromRoute(this.props);
  }

  handlePropsStepChange = prevProps => {
    const { isAllowed } = parseTransition(prevProps.step, this.props.step);
    if (isAllowed && this.needsUpdate) {
      history.push(this.props.experienceUrl + ROUTES.booking[this.props.step]);
    }
  };

  handleRouteStepChange = prevProps => {
    const prevRouteStep = bookingStepFromRoute(prevProps);
    const newRouteStep = bookingStepFromRoute(this.props);

    const hasStepChanged = prevRouteStep !== newRouteStep;
    const isNewStepDefined = !isNil(newRouteStep);

    if (hasStepChanged && isNewStepDefined && this.needsUpdate) {
      const { isAllowed, offset } = parseTransition(prevRouteStep, newRouteStep);

      if (isAllowed) {
        (offset < 0 ? this.props.prevStep : this.props.nextStep)();
      } else {
        history.push(this.props.experienceUrl);
      }
    }
  };

  render() {
    return this.props.children;
  }
}
